module.exports = __webpack_public_path__ + "static/business-icons-be6c6bffbd54cb78f3ba52c34bd952bb.jpg";